'use strict';

var _ = require('lodash');
var SaveButtonUtilsService = function SaveButtonUtilsService() {
  function getEditedRows(jqxGridSettings) {
    var gridData = getAllRows(jqxGridSettings);
    return getEditedRowsFromData(gridData);
  }
  function getEditedRowsFromData(data) {
    return _.chain(data).filter('_old').cloneDeep().value();
  }
  function getAllRows(jqxGridSettings) {
    if (!jqxGridSettings) {
      return [];
    }
    var source = jqxGridSettings.source;
    return source ? source.loadedData : [];
  }
  function isSingleFlightDepartureDateSelected(rows) {
    if (rows.length === 0) {
      return false;
    }
    if (rows.length === 1) {
      return true;
    }
    var result = false;
    var firstFlightNumberIndex = rows[0].flightNumber;
    var firstFlightDepartureDateIndexMoment = rows[0].flightDepartureDateMoment;
    _.forEach(_.tail(rows), function (row) {
      result = firstFlightNumberIndex === row.flightNumber && firstFlightDepartureDateIndexMoment === row.flightDepartureDateMoment;
      if (!result) {
        return false;
      }
    });
    return result;
  }
  return {
    getEditedRows: getEditedRows,
    getEditedRowsFromData: getEditedRowsFromData,
    getAllRows: getAllRows,
    isSingleFlightDepartureDateSelected: isSingleFlightDepartureDateSelected
  };
};
SaveButtonUtilsService.$inject = [];
module.exports = SaveButtonUtilsService;